import OnOffSwitch from './OnOffSwitch';

export default function DefaultAddPicker({
  defaultAddPosts,
  setDefaultAddPosts,
}) {
  return (
    <OnOffSwitch
      value={defaultAddPosts}
      setValue={setDefaultAddPosts}
      title="Add new posts by default?"
      description={`This option is recommended if you only have one blog and want to add
    most or all of the future posts you publish on TravelFeed to it. You
    can always customize to which blogs your posts gets added under
    "visibility" in the sidebar of the editor of each post.`}
      label="Add new posts to this blog by default"
    />
  );
}
